import { gql } from '@apollo/client';
import { ssrApolloService } from '@scorenco/core';
import { NextPageWithLayout, ssrIsAuthenticated } from '@scorenco/next';

import { MobileLayout } from '@/layouts';

const Index: NextPageWithLayout = () => {
  // WARNING: A ne pas utiliser, les pages au sens nextjs ne correspondent pas
  // au routage une fois que l'on passe en version mobile.
  //
  // Uniquement les méthodes getXXX sont à utiliser si besoin
  return <></>;
};

export const getServerSideProps = MobileLayout.buildGetServerSideProps(
  {
    i18n: { defaultLocale: 'fr' },
  },
  [
    async ({ req, res, query }, previous) => {
      try {
        const authenticated = await ssrIsAuthenticated({
          request: req,
          response: res,
        });

        if (!authenticated && process.env.NODE_ENV !== 'development') {
          const { apolloClient } = ssrApolloService();

          const eventQuery = await apolloClient.query({
            query: gql`
              query GetEventSlugInfo($eventId: Int!) {
                competitions_event_detail_by_id(args: { id: $eventId }) {
                  url
                }
              }
            `,
            variables: { eventId: Number(query.eventId) },
          });
          const event = eventQuery.data.competitions_event_detail_by_id?.[0];
          if (event) {
            return {
              redirect: {
                statusCode: 302,
                destination: `${process.env.NEXT_PUBLIC_WEB_URL}${event.url}`,
              },
            };
          }
        }
      } catch (e) {
        // Do nothing
        console.log('error : ', e);
      }

      return previous;
    },
  ]
);

Index.getLayout = MobileLayout.buildGetLayout();

export default Index;
